var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 150,
    viewBox: "0 0 175 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vue"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path893",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.163 0.0302734H174.628L87.6005 150L0 0.0302734H35.2497L87.6005 90.3151L140.163 0.0302734Z",
    fill: "#41B883"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path895",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.59 0H140.37L87.5539 90.4731L35.1621 0H67.4296L87.5539 34.8307L107.59 0Z",
    fill: "#35495E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVue);
export default __webpack_public_path__ + "static/media/vue.163d32afa01b73add0db454d4d94fadf.svg";
export { ForwardRef as ReactComponent };